 (function($){
  'use strict';

  if(!$.gnv){
      $.gnv = new Object();
  };

  $.gnv.enableHeaderFixed = function (){
    $('[data-header-fixed]').gnv_headerFixed();
  };

   $.gnv.headerFixed = function(el, options){
    var base = this;

    base.$el = $(el);
    base.el = el;

    base.lastScrollTop = 0;
    base.scroll = 0;
    base.home = false;
    base.homeLogo = 0;
    base.goDownActive = false;

    base.$el.data("gnv.headerFixed", base);

    base.init = function(){
      base.options = $.extend({},$.gnv.headerFixed.defaultOptions, options);

      if ($('body').hasClass('o-layout--home')) {
        base.home = true;
        base.homeLogo = $('.c-hero__title--home').offset().top;
      }

      // Animations on scroll
      $(window).on('scroll', function(){
        if(!base.$el.hasClass('c-header--show_mobile'))
          base.debounce(base.run(), 10);
      });

      if ($('#parallax_origin').length)
        $('#parallax_origin').on('scroll', function(){
          if($(window).width() > 768)
            if(!base.$el.hasClass('c-header--show_mobile'))
              base.debounce(base.run(), 10);
        });

      $(window).on('resize', function(){
        if ($(window).width() > 1024) {
          base.$el.removeClass('c-header--mobile');
        } else {
          if(base.$el.hasClass('c-header--show_mobile'))
            base.$el.addClass('c-header--mobile');
        }
      });

      // $('.has-dropdown > a').on('click', function(e){
      $('.has-dropdown > .dropdown-label').on('click', function(e){
        e.preventDefault();

        if(base.$el.hasClass('c-header--mobile')) {
          $(this).next('.dropdown').toggle();
        }

      });

      $(window).on('resize', function(){
        if ($(window).width() > 768) {
          $('.dropdown').removeAttr("style");
        }
      });

      $('#menu_mobile_toggle').on('click', function(e){
        e.preventDefault();

        base.$el.toggleClass('c-header--show_mobile c-header--mobile');
      });
    };

    base.run = function (){
      var scroll = $(window).scrollTop();

      if ($('#parallax_origin').length && $(window).width() > 768)
        scroll = $('#parallax_origin').scrollTop();

      // header
      if (base.lastScrollTop >= scroll) { //back to top
        base.goDownActive = false;
        if(base.$el.hasClass('o-fadeOutUp')){
          base.$el.removeClass('o-fadeOutUp');
          base.$el.addClass('c-header--fixed o-fadeInDown c-header--scrolled');
        } else if(!base.$el.hasClass('o-fadeInDown')){
          base.$el.addClass('c-header--fixed o-fadeInDown c-header--scrolled');
        }

        if (scroll < 5)
          base.$el.removeClass('c-header--fixed o-fadeOutUp o-fadeInDown c-header--scrolled');

      } else { //go down

        if (scroll > 6 && !base.goDownActive)
          base.$el.addClass('c-header--fixed o-fadeInDown c-header--scrolled');

        if(base.$el.hasClass('o-fadeInDown')){
          base.goDownActive = true;
          base.$el.removeClass('o-fadeInDown');
          base.$el.addClass('o-fadeOutUp');
        }

      }

      if (base.home) {
        // if (scroll > base.homeLogo) {
        //   base.$el.removeClass('c-header--nologo');
        // } else {
        //   base.$el.addClass('c-header--nologo');
        // }

      }

      base.lastScrollTop = scroll;
    };


    base.debounce = function(func, wait, immediate) {
      var timeout;
      return function() {
        var context = this, args = arguments;
        var later = function() {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    };

    base.init();
  };

  $.gnv.headerFixed.defaultOptions = {};

  $.fn.gnv_headerFixed = function(options){
    return this.each(function(){
      (new $.gnv.headerFixed(this, options));
    });
  };

  $.gnv.enableHeaderFixed();

})(jQuery);
